export default __webpack_public_path__ + "1d967bee8a355b086e8b937314416241.svg";